// src/components/common/Modal.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@/icons';
import './Modal.css';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  theme: 'dark' | 'light';
  children: React.ReactNode;
  zIndex?: number; // Nova prop opcional
  closable?: boolean; // default true — quando false, omite X e ignora click no overlay (uso em AlertDialog)
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, theme, children, zIndex, closable = true }) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      style={zIndex !== undefined ? { zIndex } : undefined}
      onClick={closable ? onClose : undefined}
    >
      <div
        className="modal-content"
        data-theme={theme}
        onClick={(e) => e.stopPropagation()}
      >
        {closable && (
          <button className="modal-close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;
